// RefreshBanner.tsx — warning banner shown at the top of NewProductScreen
// when mode === "refresh": the user is editing an existing product and
// nothing is written until the quick-compare scan is confirmed.
import React from "react";

export function RefreshBanner(): JSX.Element {
    return (
        <div
            role="alert"
            style={{
                padding: "12px 20px",
                background: "rgba(217, 119, 6, 0.08)",
                borderBottom: "1px solid var(--divider)",
                display: "flex",
                gap: 8,
                alignItems: "center"
            }}
        >
            <span style={{ color: "var(--np-warn)", fontSize: 13, fontWeight: 600 }}>
                You are editing an existing product. Saved changes are scanned first — updates can impact this
                product's features, user stories, and work products.
            </span>
        </div>
    );
}
